<template>
  <div class="main">
    <ul>
      <li v-for="(slot, slot_index) in slots" :key="slot_index">
        <span>{{ slot.start }} {{ slot.end }}</span>
        <select v-model="slot.num" v-on:change="updateSlot(slot_index, $event)">
          <option
            v-for="number in numbers"
            v-bind:value="number.value"
            v-bind:key="number.index"
          >{{ number.text }}</option>
        </select>
      </li>
    </ul>
  </div>
</template>

<script>
import { shopDB } from "../firebaseInit";

export default {
  name: "SlotManagement",
  methods: {
    updateSlot: (slot_index, event) => {
      shopDB
        .ref("slots-take")
        .child("s32")
        .child(slot_index.toString())
        .child("num")
        .set(parseInt(event.target.value));
    }
  },
  computed: {
    slots() {
      return this.$store.getters.getSlots;
    },
    numbers() {
      var numbers = [];
      for (var i = 0; i < 100; i++) {
        numbers.push({ text: i.toString() + "人", value: i, index: i });
      }
      return numbers;
    }
  }
};
</script>

<style>
</style>
